// Mirrors api/src/models/enums/entity-type.enum.ts — kept in sync by hand since the
// admin/app/api projects don't share a package. Each type's field list drives which
// extra detail inputs the entity form shows, and what the public profile page renders.
export const ENTITY_TYPES = [
    { value: 'corporation', label: 'Corporation' },
    { value: 'small_business', label: 'Small Business' },
    { value: 'government', label: 'Government' },
    { value: 'politician', label: 'Politician' },
    { value: 'law_enforcement', label: 'Law Enforcement' },
    { value: 'nonprofit', label: 'Nonprofit' },
    { value: 'organization', label: 'Organization' },
    { value: 'celebrity', label: 'Celebrity' },
    { value: 'athlete', label: 'Athlete' },
    { value: 'civilian', label: 'Civilian' },
];

export const ENTITY_TYPE_FIELDS = {
    corporation: [
        { key: 'industry', label: 'Industry' },
        { key: 'founded', label: 'Founded' },
        { key: 'headquarters', label: 'Headquarters' },
        { key: 'ceo', label: 'CEO' },
    ],
    small_business: [
        { key: 'industry', label: 'Industry' },
        { key: 'location', label: 'Location' },
        { key: 'owner', label: 'Owner' },
    ],
    government: [
        { key: 'jurisdiction', label: 'Jurisdiction' },
        { key: 'agency', label: 'Agency / Department' },
    ],
    politician: [
        { key: 'position', label: 'Position' },
        { key: 'party', label: 'Party' },
        { key: 'jurisdiction', label: 'Jurisdiction' },
    ],
    law_enforcement: [
        { key: 'department', label: 'Department' },
        { key: 'rank', label: 'Rank / Title' },
        { key: 'jurisdiction', label: 'Jurisdiction' },
    ],
    nonprofit: [
        { key: 'cause', label: 'Cause / Mission' },
        { key: 'founded', label: 'Founded' },
    ],
    organization: [
        { key: 'industry', label: 'Industry / Field' },
        { key: 'founded', label: 'Founded' },
    ],
    celebrity: [
        { key: 'profession', label: 'Profession' },
        { key: 'knownFor', label: 'Known For' },
    ],
    athlete: [
        { key: 'sport', label: 'Sport' },
        { key: 'team', label: 'Team' },
        { key: 'position', label: 'Position' },
    ],
    civilian: [
        { key: 'location', label: 'Location' },
        { key: 'occupation', label: 'Occupation' },
    ],
};
